<template>
  <v-container flat fluid>
    <v-row no-gutters>
      <v-col v-for="(card, index) in cards" :key="index" :cols="card.width">
        <v-card color="primary" class="pa-3 ma-1" dark>
          <h3>{{ card.label }}</h3>
          <h2>{{ card.text }}</h2>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-subheader>Status</v-subheader>
        <v-alert
          class="ma-0"
          text
          outlined
          :color="client.complete ? 'green' : 'red'"
          :icon="client.complete ? 'mdi-check-circle' : 'mdi-alert'"
          >{{ client.complete ? "Complete" : "Incomplete" }}</v-alert
        >
      </v-col>
      <v-col cols="6">
        <v-subheader>Alerts</v-subheader>
        <v-alert
          v-if="alerts.length == 0"
          class="ma-0"
          text
          outlined
          color="green"
          icon="mdi-check-circle"
          >No Alerts</v-alert
        >
        <v-alert
          v-for="(alert, index) in alerts"
          :key="index"
          class="ma-0"
          text
          outlined
          :color="alert.expired ? 'red' : 'orange'"
          icon="mdi-alert"
          >{{ `${alert.type}: ${alertExpiryDescription(alert)}` }}</v-alert
        >
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment, { min } from "moment";

export default {
  props: {
    client: Object,
  },
  data() {
    return {};
  },
  computed: {
    cards() {
      return [
        {
          label: "Contact #",
          text: this.client.name,
          width: 6,
        },
        {
          label: "Start Date",
          text: this.client.registered
            ? moment(this.client.registered).format("DD/MM/YY")
            : "##/##/####",
          width: 6,
        },
        {
          label: "Bookings",
          text: "78",
          width: 6,
        },
        {
          label: "Complaints",
          text: "1",
          width: 6,
        },
      ];
    },
    alerts() {
      var alerts = [];
      var now = moment();
      this.client.attributes.forEach((attr) => {
        if (attr.type == "Date" && attr.reminder != "None") {
          var date = moment(attr.attribute);
          if (now.isAfter(date)) {
            alerts.push({
              type: attr.label,
              expired: true,
              date: date,
              days: date.diff(now, "d"),
            });
          } else if (now.isAfter(moment(attr.reminderDate))) {
            alerts.push({
              type: attr.label,
              expired: false,
              date: date,
              days: date.diff(now, "d"),
            });
          }
        }
      });
      return alerts;
    },
  },
  methods: {
    alertExpiryDescription(alert) {
      var desc = "";
      if (alert.expired) {
        desc += "Expired";
      } else {
        desc += "Expires";
        if (alert.days == 0) {
          desc += " today";
        } else if (alert.days == 1) {
          desc += " in 1 day";
        } else {
          desc += `in ${alert.days} days`;
        }
      }
      return desc;
    },
  },
};
</script>

